// extracted by mini-css-extract-plugin
export default {"Embed":"Embed_Embed__-4wcZ"};